import gql from 'graphql-tag';

export const TOP_10_HOLDINGS_QUERY = gql`
  query TopTenHoldings($ticker: String!) {
    mutualFund(ticker: $ticker) {
      bond
      selectiveDisclosures {
        monthly {
          asOfDate
          top10CalculatedPercentage
          individualHoldings {
            rank
            name
            percentTotalNetAssets
            issuerGuarantorTypeName
          }
        }
      }
    }
  }
`;

const queryData = {
  mutualFund: {
    bond: false,
    selectiveDisclosures: {
      monthly: [
        {
          asOfDate: '2025-07-31T04:00:00Z',
          top10CalculatedPercentage: 43.463769,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 10.359491,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.243977,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.469409,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.098045,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.595754,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'Saudi Arabian Oil',
              percentTotalNetAssets: 3.347699,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'FirstRand',
              percentTotalNetAssets: 2.924353,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.827689,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Emaar Properties',
              percentTotalNetAssets: 2.339126,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'Anglogold Ashanti',
              percentTotalNetAssets: 2.258226,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ],
          __typename: 'SelectiveDisclosure'
        },
        {
          asOfDate: '2025-06-30T04:00:00Z',
          top10CalculatedPercentage: 45.132749000000004,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 10.545251,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.131748,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.591195,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.080589,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'Saudi Arabian Oil',
              percentTotalNetAssets: 3.41594,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'Northam Platinum Holdings',
              percentTotalNetAssets: 3.407125,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.279893,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'First Abu Dhabi Bank',
              percentTotalNetAssets: 2.981868,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.907103,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'FirstRand',
              percentTotalNetAssets: 2.792037,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ],
          __typename: 'SelectiveDisclosure'
        },
        {
          asOfDate: '2025-05-31T04:00:00Z',
          top10CalculatedPercentage: 43.585558999999996,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 10.546629,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.117805,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.35211,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.141482,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.24904,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'First Abu Dhabi Bank',
              percentTotalNetAssets: 3.004354,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.884726,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'FirstRand',
              percentTotalNetAssets: 2.81009,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Northam Platinum Holdings',
              percentTotalNetAssets: 2.751919,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'Saudi Awwal Bank',
              percentTotalNetAssets: 2.727404,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ],
          __typename: 'SelectiveDisclosure'
        },
        {
          asOfDate: '2025-03-31T04:00:00Z',
          top10CalculatedPercentage: 45.300881,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 12.506578,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.440195,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.282964,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.00767,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.438437,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'Saudi Awwal Bank',
              percentTotalNetAssets: 3.401143,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'FirstRand',
              percentTotalNetAssets: 2.710086,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'First Abu Dhabi Bank',
              percentTotalNetAssets: 2.627286,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.507035,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'Northam Platinum Holdings',
              percentTotalNetAssets: 2.379487,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ],
          __typename: 'SelectiveDisclosure'
        },
        {
          asOfDate: '2025-02-28T05:00:00Z',
          top10CalculatedPercentage: 45.515413,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 12.526364,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.436267,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.254296,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.379365,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.454121,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'Saudi Awwal Bank',
              percentTotalNetAssets: 3.286647,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'First Abu Dhabi Bank',
              percentTotalNetAssets: 2.770858,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'FirstRand',
              percentTotalNetAssets: 2.703444,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.517689,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'Etihad Etisalat',
              percentTotalNetAssets: 2.186362,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ],
          __typename: 'SelectiveDisclosure'
        }
      ],
      __typename: 'SelectiveDisclosures'
    },
    __typename: 'GraphQLMutualFund'
  }
};

export const TOP_10_HOLDINGS_QUERY_MOCK = [
  {
    request: {
      query: TOP_10_HOLDINGS_QUERY,
      variables: {
        ticker: 'TRBCX'
      }
    },
    result: {
      data: queryData
    }
  }
];
